<template lang="pug">
  div.heroList
    van-grid(:column-num="3", :center="false")
      van-grid-item(v-for="item in dataList", @click="showHeroContent(item)")
        div.heroItem
          img(alt="", v-lazy="require('../assets/hero_icon/'+item.heroIcon)")
</template>

<script>
export default {
  name: 'HeroList',
  data() {
    return {
      dataList:[],
      heroItemList:[],
    }
  },
  created() {
    
  },
  methods:{
    initList() {
      for (let index = 0; index < this.heroItemList.length; index++) {
        this.dataList.push(this.heroItemList[index]);
      }
    },
    showHeroContent(item) {
      this.$router.push({
        path: "/hero/content/"+item.heroId
      })
    }
  },
  components:{

  },
  mounted() {
    let wikiData = require("../assets/lang/zh_CN.json")
    this.$nextTick(() => {
      this.heroItemList = wikiData.heroItemList
      this.initList()
    })
  }
}
</script>

<style lang="scss">
.heroList {
  .van-grid-item__content {
    padding: 0px;
    min-width: 114px;
    height: 152px;
    background-color: transparent;
    background-size: contain;
  }
  .van-hairline--top::after {
    border-top-width: 0px;
  }
  .van-grid-item__content::after{
    border-width: 0px;
  }
  .van-grid-item {
    padding: 10px 0;
    justify-content: center;
    display: flex;
  }
  .heroItem {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
  }
  .heroItem img {
    width: 100%;
    height: 100%;
  }
}
</style>